import {
    SavingAllFilesToOneDriveConsumerPrefixText,
    SavingAllFilesToGroupFilesText,
    SavingAllFilesToOneDrivePrefixText,
    FailedToSaveMultipleFilesToGroupFilesText,
    FailedToSaveMultipleFilesToOneDriveText,
    SavedAllFilesToGroupFilesText,
    SavedAllFilesToOneDrivePrefixText,
    CanceledSaveToOneDriveText,
} from './getSaveAllToCloudStatusLabel.locstring.json';
import { ConsumerDefaultSaveToCloudLocationText } from 'owa-locstrings/lib/strings/consumerdefaultsavetocloudlocationtext.locstring.json';
import { OneDriveText } from 'owa-locstrings/lib/strings/onedrivetext.locstring.json';
import { ActionsPanel_DefaultUploadFolderName } from 'owa-locstrings/lib/strings/actionspanel_defaultuploadfoldername.locstring.json';
import loc, { format } from 'owa-localize';
import { assertNever } from 'owa-assert';
import { getCompanyName } from 'owa-attachment-data';
import SaveAllToCloudStatus from 'owa-attachment-well-data/lib/schema/SaveAllToCloudStatus';
import { fetchUploadFolder, getUploadFolder } from 'owa-attachments-upload-folder';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isNullOrWhiteSpace } from 'owa-string-utils';

function getFolderName(mailboxId: string): string {
    const uploadeFolder = getUploadFolder(mailboxId);
    if (uploadeFolder) {
        return uploadeFolder.folderName;
    } else {
        fetchUploadFolder(mailboxId);
        return null;
    }
}

export default function getSaveAllToCloudStatusLabel(
    mailboxId: string,
    isGroup: boolean,
    saveAllToCloudStatus: SaveAllToCloudStatus
): string {
    const defaultConsumerSaveLocation: string = loc(ConsumerDefaultSaveToCloudLocationText);
    switch (saveAllToCloudStatus) {
        case SaveAllToCloudStatus.InProgress:
            if (isConsumer()) {
                return format(
                    loc(SavingAllFilesToOneDriveConsumerPrefixText),
                    getCompanyName(),
                    defaultConsumerSaveLocation
                );
            } else if (isGroup) {
                return loc(SavingAllFilesToGroupFilesText);
            } else {
                return format(loc(SavingAllFilesToOneDrivePrefixText), loc(OneDriveText));
            }
        case SaveAllToCloudStatus.Failed:
            if (isGroup) {
                return loc(FailedToSaveMultipleFilesToGroupFilesText);
            }

            return format(
                loc(FailedToSaveMultipleFilesToOneDriveText),
                isConsumer() ? defaultConsumerSaveLocation : loc(OneDriveText)
            );
        case SaveAllToCloudStatus.Completed:
            if (isGroup) {
                return loc(SavedAllFilesToGroupFilesText);
            }
            let folderName = getFolderName(mailboxId);
            if (isNullOrWhiteSpace(folderName)) {
                folderName = loc(ActionsPanel_DefaultUploadFolderName);
            }
            return format(loc(SavedAllFilesToOneDrivePrefixText), folderName);
        case SaveAllToCloudStatus.Canceled:
            return loc(CanceledSaveToOneDriveText);
        case SaveAllToCloudStatus.Inactive:
            throw new Error('Unsupported SaveAllToCloudStatus: ' + saveAllToCloudStatus);
        default:
            assertNever(saveAllToCloudStatus);
            return '';
    }
}
